import styled from 'styled-components';

const H0 = styled.h1`
 font-size: 48px;
    font-weight: 500;
    color: black;
`;

export default H0;
